import type { FileInfo } from '../state';

/**
 * A request body meaning "the whole of this file", for the uploads that send a
 * file in one request instead of in chunks.
 *
 * What can carry a whole file is platform specific — a browser has a File, node
 * has a path to re-open — and the http client is already the platform's own, so
 * it is left to resolve this into something it can send. Carrying the FileInfo
 * rather than the source alone lets it set a content length without a stat.
 */
export class WholeFileBody {
  constructor(readonly fileInfo: FileInfo) {}
}
